const RECEIVERS_TYPE_ENUM = {
  SINGLE: 'SINGLE',
  SPLIT: 'SPLIT'
}

const isReceiversTypeSingle = receiversType =>
  receiversType.toLowerCase() === RECEIVERS_TYPE_ENUM.SINGLE.toLowerCase()
const isReceiversTypeSplit = receiversType =>
  receiversType.toLowerCase() === RECEIVERS_TYPE_ENUM.SPLIT.toLowerCase()

export { RECEIVERS_TYPE_ENUM, isReceiversTypeSplit, isReceiversTypeSingle }
